const initializePcBaseData = (json) => {
  if (document.querySelector(".jsMainHeader")) {
    initializePcHeader(json.current_person, json.bookmarking_count);
  }
  if (document.querySelector("#jsMainFooter")) {
    initializePcFooter(json.current_person, json.current_user);
  }
  if (document.querySelector("#jsHomeHeader")) {
    initializePcHomeHeader(json);
  }
  if (document.querySelector("#jsSpreadHeader")) {
    initializePcSpreadHeader(json.current_person);
  }
  if (
    json.current_user &&
    document.querySelector(".jsPcAppearUP") &&
    json.current_user.id ==
      document.querySelector(".jsPcAppearUP").dataset.articleUserId
  ) {
    initializePcArticleEditBar(
      document.querySelector(".jsPcAppearUP").dataset.articleId
    );
  }
};

const initializePcHeader = (current_person, bookmarking_count) => {
  if (current_person) {
    $("#jsHeaderRegister")
      .text("マイページ")
      .attr("href", Routes.mypage_people_path())
      .removeAttr("rel");
  }
  const bookmark_text = `お気に入り${
    bookmarking_count == 0 ? "" : `(${bookmarking_count})`
  }`;
  $("#jsHeaderBookmark").text(bookmark_text);
};

const initializePcFooter = (current_person, current_user) => {
  if (current_person) {
    $("#jsFooterRegister")
      .text("マイページ")
      .attr("href", Routes.mypage_people_path())
      .removeAttr("rel");
    $("#jsFooterLogin")
      .text("ログアウト")
      .attr("href", Routes.destroy_person_session_path())
      .removeAttr("rel");
  }
  if (current_user) {
    $("#jsFooterUserZone").prepend(
      `<li class='footerItem'><a href='/manage/top'>管理画面TOPへ</a></li>`
    );
  }
};

const initializePcHomeHeader = (json) => {
  $("#jsHomeHeaderBookmarkCount").text(json.bookmarking_count);
  $("#jsHomeHeaderRecentCount").text(json.recently_viewed_articles_count);
  if (json.current_person) {
    $("#jsHeaderRegister")
      .text("マイページ")
      .attr("href", Routes.mypage_people_path())
      .removeAttr("rel");
  }
};

const initializePcSpreadHeader = (current_person) => {
  if (current_person) {
    $("#jsSimpleHeaderLogin")
      .text("マイページ")
      .attr("href", Routes.mypage_people_path())
      .removeAttr("rel");
    $("#jsSimpleHeaderRegister")
      .text("ログアウト")
      .attr("href", Routes.destroy_person_session_path())
      .removeAttr("rel");
  }
};

const initializePcArticleEditBar = (article_id) => {
  $(".jsPcAppearUP").empty();
  // NOTE: manage配下以外にも複数ページで使用されているため、js-routesを使わないでroutesを定義している。
  $(".jsPcAppearUP").append(
    `  <div class='pageEditOverlayContent'>` +
      `    <a href='/manage/articles/${article_id}/edit' class='p_btn isEdit isLarge isRedAccent isWide'>ページ編集</a>` +
      `  </div>`
  );
};

// NOTE: esbuild IIFE バンドルではモジュールスコープが分離されるため、グローバルに公開する

export default initializePcBaseData;